import React from 'react';
import {Subtitle, HelperText} from '@worthy-npm/clarity'
import {imageUrl} from 'helpers/ApplicationHelper';

const TabH2P = ({data, active, click}) =>
    (
                <div className={`tab-H2P d-flex flex-col ${active? '': 'blur'}`} onClick={()=>click()}>
                    <div className={`tab-H2P-main d-flex`}>
                        <div className='image-container d-flex'>
                            <img alt='bar-icon' src={imageUrl(data.bigIcon)}/>
                        </div>
                        <div className='content-container d-flex flex-col'>
                            <div className=''>
                                <img alt='ring-icon' src={imageUrl(data.smallIcon)}/>
                            </div>
                            <Subtitle bold={true} text={data.tabTitle}
                                overrideCSS={{ fontFamily: 'Roboto', fontSize: '20px'}}/>
                            <HelperText text={data.tabSubtitle}/>
                        </div>
                    </div>
                    { active &&
                        <div className='active-arrow-container d-flex flex-justify-center'>
                            <img alt='arrow-down' src={imageUrl('experts/howToPrice/tabArrow.svg')}/>
                        </div> }
                </div>
    )

export default TabH2P;